module.exports = __webpack_public_path__ + "static/copywriting-e91f2b58cd79f429f7e9ef245726b080.jpg";